<template>
  <div
    v-if="resNumber > 0"
    :style="{ height: height + 'px', backgroundColor: bkServiceColor }"
    class="card noselect"
    :class="background"
    @click.stop="details"
    @mouseover.stop="expire"
  >
    <div class="toolbar">
      <div class="header">
        <h4>{{ ellipse(fullName) }}</h4>
      </div>
      <div class="path" :class="backgroundTongue" @click="move">
        <v-icon style="margin-top: 1px">import_export</v-icon>
      </div>
    </div>
    <div class="content">
      <span class="divider"></span>
      <div>
        <h4>
          {{ ellipse(selectedTime) }}
          <v-icon
            size="20"
            v-show="selectedCard.note !== '' && selectedCard.note !== null"
            >insert_drive_file
          </v-icon>
          <v-icon size="20" v-show="selectedCard.referenceUsers === 0"
            >computer
          </v-icon>
          <v-icon size="20" v-show="selectedCard.referenceUsers > 0"
            >smartphone
          </v-icon>
          <v-icon
            size="20"
            v-show="
              selectedCard.isLastOne || showWarningSeriesRes(selectedCard)
            "
            class="q-danger-bk"
            >warning
          </v-icon>
        </h4>
      </div>
      <span class="divider"></span>
      <div>
        <h4>{{ ellipse(selectedService) }}</h4>
      </div>
      <div
        class="swap"
        :class="background"
        v-show="resNumber > 1"
        @click="changeCard"
      >
        <v-icon color="white" style="font-size: 18px">play_arrow</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "../../../utils.js";
import Moment from "moment";
var ut = new Utils();
export default {
  name: "CalCard",
  props: {
    day: {
      type: String,
      default: "01",
    },
    emp: {
      type: Number,
      default: 0,
    },
    min: {
      type: String,
      default: "00",
    },
    hour: {
      type: String,
      default: "00",
    },
    empId: {
      type: Number,
      default: 0,
    },
    fullDate: {
      type: String,
      default: "",
    },
  },

  mounted: function () {
    const saved = localStorage.getItem("serviceColor");
    if (saved !== null) {
      this.serviceColor = JSON.parse(saved);
    }
    this.empBk = parseInt(this.emp);
    if (this.resNumber > 0) this.selectedCard = this.cards[this.selectedIndex];
    this.hasPassed =
      new Moment().diff(
        new Moment(this.fullDate).add(this.hour, "h").add(this.min, "m")
      ) > 0;
  },
  computed: {
    bkServiceColor: function () {
      if (this.serviceColor)
        return ut.getRandomColorByHash(this.selectedCard.service.split(",")[0]);
      return null;
    },
    background: function () {
      var bk = {};
      var v1 = "v-card-background-" + this.empBk;
      bk[v1] = true;
      bk["card-new"] = this.hasNew;
      bk["card-reduced"] = this.reduced;
      bk["card-past"] = this.hasPassed;
      return bk;
    },
    backgroundTongue: function () {
      var bt = {};
      var v1 = "v-card-background-" + this.empBk;
      bt[v1] = !this.hasNew;
      bt["card-new-tongue"] = this.hasNew;
      return bt;
    },
    fullName: function () {
      return this.selectedCard.uSurname + " " + this.selectedCard.uName;
    },
    selectedService: function () {
      return this.selectedCard.service.replace(/[,]/g, ", ");
    },
    selectedTime: function () {
      return (
        this.getTimeFormat(this.selectedCard.dateAndTime) +
        "-" +
        this.getTimeFormat(this.selectedCard.dateEnd)
      );
    },
    getDate: function () {
      return this.selectedCard.dateAndTime.split("T")[0];
    },
    getEmail: function () {
      if (this.selectedCard.email === null) return this.getString("Nessuna");
      return this.selectedCard.email;
    },
    getPhone: function () {
      if (this.selectedCard.phone === null)
        if (this.selectedCard.flyPhone === null)
          return this.getString("Nessuno");
        else return this.selectedCard.flyPhone;
      else return this.selectedCard.phone;
    },
    resNumber: function () {
      return this.cards.length;
    },
    getCardCoord: function () {
      return {
        day: this.day,
        hour: this.hour,
        min: this.min,
        emp: this.empId,
      };
    },
    height: function () {
      var max = 10;
      for (var i = 0; i < this.cards.length; i++) {
        if (this.cards[i].min >= max) max = this.cards[i].min;
      }
      return max * 4 - 4;
    },
    top: function () {
      var min = 0;
      min = Number.parseInt(this.min) % 30;
      return min;
    },
  },
  data: () => {
    return {
      cards: [],
      selectedIndex: 0,
      empBk: 0,
      hasNew: false,
      reduced: false,
      hasPassed: false,
      serviceColor: false,
      selectedCard: {
        nameEmployee: null,
        photo: null,
        uName: "Name Ph asdas das da fas fas",
        uSurname: "Surname Ph",
        idReservation: 0,
        dateAndTime: "0001-01-01T00:00:00",
        dateEnd: "0001-01-01T00:00:00",
        referenceUsers: 0,
        referenceBarberShop: 0,
        referenceEmployee: 0,
        state: 0,
        email: null,
        phone: null,
        note: null,
        service: null,
        flyName: null,
        flySurname: null,
        flyPhone: null,
        min: 10,
      },
    };
  },

  methods: {
    reset: function () {
      this.cards = [];
      this.selectedIndex = 0;
    },
    showWarningSeriesRes: function (card) {
      return (
        !card.isLastOne &&
        card.lastReservationDate &&
        this.getDiffDays(card.lastReservationDate, card.dateAndTime) < 60
      );
    },
    getDiffDays: function (date, date2) {
      const m2 = new Moment(date2);
      const diffDays = new Moment(date).diff(m2, "days");
      return diffDays;
    },
    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    expire() {
      this.hasNew = false;
    },
    getResNumber() {
      return this.resNumber;
    },
    details: function (evt) {
      if (this.resNumber > 1) {
        this.$emit("multiDetails", { cards: this.cards, cardRef: this });
      } else {
        this.$emit("details", this);
      }
    },
    move: function (evt) {
      evt.stopPropagation();
      this.$emit("move", {
        day: this.day,
        hour: this.hour,
        min: this.min,
        emp: this.empId,
        card: this,
      });
    },
    ellipse: function (str) {
      if (str === null) return;
      if (str.length > this.height / 2.5) return str.substring(0, 20) + "...";
      return str;
    },
    setEmp: function (i) {
      this.empBk = i;
    },
    changeCard: function (evt) {
      evt.stopPropagation();
      this.selectedIndex++;
      if (this.selectedIndex >= this.cards.length) {
        this.selectedIndex = 0;
      }
      this.selectedCard = this.cards[this.selectedIndex];
    },
    getTimeFormat(date) {
      return (
        date.split("T")[1].split(":")[0] +
        ":" +
        date.split("T")[1].split(":")[1]
      );
    },
    pushCard: function (card, isNew) {
      for (let index = 0; index < this.cards.length; index++) {
        const element = this.cards[index];
        if (element.idReservation === card.idReservation) return;
      }
      this.$set(this.cards, this.cards.length, card);
      if (this.cards.length === 1) this.selectedCard = this.cards[0];
      this.hasNew = isNew;
    },
    popCard: function (idres) {
      var temp = [];
      var tempI = -1;
      for (var i = 0; i < this.cards.length; i++) {
        if (this.cards[i].idReservation === idres) {
          tempI = i;
        }
      }
      for (var j = 0; j < this.cards.length; j++) {
        if (j !== tempI) temp.push(this.cards[j]);
      }
      this.cards = temp;
      this.selectedIndex = 0;
      if (this.cards.length > 0)
        this.selectedCard = this.cards[this.selectedIndex];
    },
  },
};
</script>

<style scoped>
.card .header {
  width: 198px;
  color: #333;
  padding-left: 3px;
  padding-right: 3px;
}

.card .header h4 {
  font-weight: bold;
}

.card .path {
  width: 30px;
  height: 25px;
  padding-bottom: 2px;
  cursor: pointer;
  border-top: solid 2px whitesmoke;
  transition: background-color 0.4s linear;
  -o-transition: background-color 0.4s linear;
  -ms-transition: background-color 0.4s linear;
  -webkit-transition: background-color 0.4s linear;
  -moz-transition: background-color 0.4s linear;
}

.card .path i {
  line-height: 20px;
}

.card .toolbar {
  width: 230px;
  display: flex;
  min-height: 20px;
  background: transparent;
}

.card .content {
  position: relative;
  overflow: hidden;
  padding-left: 3px;
  padding-right: 3px;
  color: whitesmoke;
  flex-grow: 1;
}

.card .content h4 {
  font-weight: lighter;
  color: #333;
}

.card .divider {
  border-top: #fff 1px solid;
  width: 120px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
}

.card .swap {
  position: absolute;
  bottom: 3px;
  right: 5px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  color: whitesmoke;
  transition: background-color 0.4s linear;
  -o-transition: background-color 0.4s linear;
  -ms-transition: background-color 0.4s linear;
  -webkit-transition: background-color 0.4s linear;
  -moz-transition: background-color 0.4s linear;
  box-shadow: 0 0 7px #fff;
  border-radius: 50px;
}

.card .swap:hover {
  background-color: darkcyan;
}

.card {
  position: relative;
  z-index: 1;
  width: 198px;
  text-align: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.4s linear;
  -o-transition: all 0.4s linear;
  -ms-transition: all 0.4s linear;
  -webkit-transition: all 0.4s linear;
  -moz-transition: all 0.4s linear;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  border: solid 2px rgba(0, 0, 0, 0.3);
}

.card:hover {
  z-index: 1000;
}

.v-card-background-0 {
  background: #33cc66;
}

.v-card-background-1 {
  background: #6699cc;
}

.v-card-background-2 {
  background: #cccc66;
}

.v-card-background-3 {
  background: #cc99cc;
}

.v-card-background-4 {
  background: #ff9966;
}

.v-card-background-5 {
  background: #999999;
}

.v-card-background-6 {
  background: #9999cc;
}

.v-card-background-7 {
  background: #669999;
}

.v-card-background-8 {
  background: #cccc99;
}

.v-card-background-9 {
  background: #ff99cc;
}

.v-card-background-10 {
  background: #ffcc33;
}

.v-card-background-11 {
  background: #cc6666;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
  supported by Chrome and Opera */
}
.card-reduced {
  width: 158px;
}
/* .card-new {
  border-color: red;
} */
/* .card-new-tounge {
  background: red !important;
} */
.card-new {
  background: linear-gradient(
    -45deg,
    #ee7752,
    #d5725b,
    rgb(211, 199, 38),
    #d5725b
  );
  background-size: 400% 400% ;
  -webkit-animation: Gradient 3s ease-in-out infinite ;
  -moz-animation: Gradient 3s ease-in-out infinite ;
  animation: Gradient 3s ease-in-out infinite ;
}
.card-new-tongue {
  background: linear-gradient(
    -45deg,
    #ee7752,
    #d5725b,
    rgb(211, 199, 38),
    #d5725b
  ) !important;
  background-size: 400% 400%;
  -webkit-animation: Gradient 5s linear infinite;
  -moz-animation: Gradient 5s linear infinite;
  animation: Gradient 5s linear infinite;
}
.card-past {
  background-color: #d4cece !important;
}
@-webkit-keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@-moz-keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes Gradient {
  0% {
    background-position: 0% 30%;
  }
  50% {
    background-position: 50% 40%;
  }
  100% {
    background-position: 0% 30%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/CalCard.vue